export default __webpack_public_path__ + "static/media/openBook.65ee1fe1.svg";